import { render, staticRenderFns } from "./fqxzQuestion.vue?vue&type=template&id=3b874903&scoped=true&"
import script from "./fqxzQuestion.vue?vue&type=script&lang=js&"
export * from "./fqxzQuestion.vue?vue&type=script&lang=js&"
import style0 from "./fqxzQuestion.vue?vue&type=style&index=0&id=3b874903&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b874903",
  null
  
)

export default component.exports